import { Dispatch, SetStateAction, MouseEvent } from "react"
import { ToggleButton, ToggleButtonGroup } from "@mui/material"
import { AutoclaveSelection } from "../../enums"

type AutoclaveToggle = {
  selection: AutoclaveSelection,
  setSelection: Dispatch<SetStateAction<AutoclaveSelection>>,
}

const AutoclaveToggle = (props: AutoclaveToggle) => {
  const { selection, setSelection } = props

  const buttonStyles = { paddingLeft: '16px', paddingRight: '16px' }

  const handleChange = (event: MouseEvent<HTMLElement>, value: AutoclaveSelection) => {
    if (value) {
      setSelection(value)
    }
  }

  return (
    <ToggleButtonGroup
      size="small"
      color="primary"
      value={selection}
      exclusive
      onChange={handleChange}
    >
      <ToggleButton value={AutoclaveSelection.TestResults} sx={{...buttonStyles, minWidth: '145px' }} >
        Results
      </ToggleButton>
      <ToggleButton value={AutoclaveSelection.TestLogs} sx={{...buttonStyles, minWidth: '165px' }}>
        Audit Log
      </ToggleButton>
    </ToggleButtonGroup>    
  )
}

export default AutoclaveToggle
